export class NominatimResponse {
	constructor(
		public longitude: number,
		public latitude: number,
		public displayName: string
	) {}
}
